module.exports = __webpack_public_path__ + "assets/img/yingyong.cc8d3865.png";